const humanize = (name = '') => name.split('.').splice(-1)[0].replace('_', ' ')
export default humanize
